// extracted by mini-css-extract-plugin
export default {"contrast":"Projects_contrast__zFaWq","h2":"Projects_h2__z6zaI","projects":"Projects_projects__honim"};